import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import { motion } from "framer-motion";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// Group commandments into pairs of two
const commandments = [
  [
    {
      title: "1. Honor Thy Word",
      description:
        "Always keep promises and commitments. Your word is your bond.",
    },
    {
      title: "2. Respect All",
      description:
        "Treat everyone with respect, regardless of their status, race, or belief.",
    },
  ],
  [
    {
      title: "3. Practice Kindness",
      description:
        "Act with kindness and empathy, even in the smallest of interactions.",
    },
    {
      title: "4. Seek Knowledge",
      description:
        "Dedicate time each day to learn something new, fostering wisdom and understanding.",
    },
  ],
  [
    {
      title: "5. Lead by Example",
      description:
        "Be a role model in your conduct, inspiring others through actions rather than words.",
    },
    {
      title: "6. Defend the Vulnerable",
      description:
        "Stand up for those who cannot defend themselves, promote justice and fairness.",
    },
  ],
  [
    {
      title: "7. Cultivate Humility",
      description:
        "Acknowledge your mistakes, learn from them, and always remain humble.",
    },
    {
      title: "8. Maintain Integrity",
      description:
        "Act with integrity even when no one is watching; let your moral principles guide you.",
    },
  ],
  [
    {
      title: "9. Promote Peace",
      description:
        "Avoid unnecessary conflict, seek resolution through dialogue, and promote peace in your environment.",
    },
    {
      title: "10. Give Back",
      description:
        "Contribute to society by volunteering, donating, or aiding in community projects. Use the $man token to fund or support these initiatives.",
    },
  ],
];

function CommandmentsCarousel() {
  return (
    <div className="max-w-screen-md mx-auto mt-20 px-6 w-full">
      <h2 className="text-center font-secondary text-2xl text-[#14A7FD] uppercase mb-8">
        The Ten Gentleman's Commandments
      </h2>

      {/* Swiper Component for sliding through commandments */}
      <Swiper
        modules={[Pagination, Navigation]}
        pagination={{ clickable: true }}
        spaceBetween={20}
        slidesPerView={1}
        className="h-[90%]"
      >
        {commandments.map((pair, index) => (
          <SwiperSlide key={index}>
            <motion.div
              initial={{ opacity: 0.5, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="bg-white p-6 shadow-md rounded-2xl border border-gray-200 "
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {pair.map((commandment, subIndex) => (
                  <div key={subIndex} className="mb-4">
                    <h3 className="text-xl font-bold text-[#14A7FD]">
                      {commandment.title}
                    </h3>
                    <p className="text-gray-700 mt-2">
                      {commandment.description}
                    </p>
                  </div>
                ))}
              </div>
            </motion.div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default CommandmentsCarousel;
